import { Component, Vue } from 'vue-property-decorator'
import { getCourseType, getStudentDetail, getCourseTime, queryCourse, getWorkOrderSign, editContinueJoin, continueJoin } from '@/api'
import { TagsViewModule } from '@/store/modules/tags-view'
@Component({ name: 'continue-student-page' })
export default class ContinueStudentPage extends Vue {
  private loading = false

  private studentId: any = null
  private studentData: any = null
  // 类型
  private typeList: any = []
  private chooseType: any = null
  // 开课时间
  private timeList: any = []
  private chooseTime: any = null
  // 项目列表
  private projectList: any = []
  private chooseProject: any = null

  private action: any = null // create-创建 edit-编辑
  private orderId: any = null // 订单Id
  created () {
    this.studentId = this.$route.query.id || null
    this.orderId = this.$route.query.orderId || null
    this.action = this.$route.query.action || 'create'
    this.initPageData()
  }

  private async initPageData () {
    this.loading = true
    if (this.action === 'edit') {
      const result: any = await getWorkOrderSign({ id: this.orderId })
      const { studentId } = result
      this.studentId = studentId
      this.studentData = result
    } else {
      this.studentData = await getStudentDetail({ id: this.studentId })
    }
    this.typeList = await getCourseType({})
    this.loading = false
  }

  // 类型选择
  private async onChooseType (item: any) {
    this.chooseType = item
    this.timeList = await getCourseTime({ courseType: this.chooseType.id })
    this.projectList = []
    if (this.timeList.length === 0) {
      this.onChooseTime(null)
    }
  }

  private async onChooseTime (item: any) {
    this.chooseTime = item
    this.projectList = await queryCourse({ courseType: this.chooseType.id, schoolBegins: this.chooseTime, studentId: this.studentId, isContinue: true })
  }

  private onChooseProject (item: any) {
    this.chooseProject = item
  }

  // 续报提交
  private async onContinueClick () {
    if (!this.chooseProject || !this.chooseProject.id) {
      this.$message({ message: '请选择续报项目', type: 'info' })
      return
    }
    // this.chooseType.id 论文类型传参
    const result: any = await continueJoin({ studentId: this.studentId, form: this.studentData.from, orderIdCrm: this.studentData.orderIdCrm, courseType: this.chooseType.id, courseId: this.chooseProject.id, commonCourseSellOrderId: this.chooseType.id === 25 || this.chooseType.id === 28 || this.chooseType.id === 29 ? this.chooseProject.sellOrderId : '' })
    if (result.errorNumber && result.errorNumber === 1) {
      this.$confirm('当前用户已经报名这个课程了，确定要重复报名？').then(async () => {
        const { error }: any = await continueJoin({ studentId: this.studentId, courseType: this.chooseType.id, courseId: this.chooseProject.id, goOn: true, commonCourseSellOrderId: this.chooseType.id === 25 || this.chooseType.id === 28 || this.chooseType.id === 29 ? this.chooseProject.sellOrderId : '' })
        if (!error) {
          this.$router.go(-1)
          TagsViewModule.delView(this.$route)
        }
      })
    } else {
      this.$router.go(-1)
      this.$message({ message: '续报成功', type: 'success' })
      window.sessionStorage.setItem('page', '')
      TagsViewModule.delView(this.$route)
    }
  }

  private async onReContinueClick () {
    // 独立论文的时候多传commonCourseSellOrderId。
    const param: any = { workOrderId: this.studentData.id, form: this.studentData.from, orderIdCrm: this.studentData.orderIdCrm, courseType: this.chooseType.id, courseId: this.chooseProject.id, commonCourseSellOrderId: this.chooseType.id === 25 || this.chooseType.id === 28 || this.chooseType.id === 29 ? this.chooseProject.sellOrderId : '' }
    const result: any = await editContinueJoin(param)
    if (result.errorNumber && result.errorNumber === 1) {
      param.goOn = true
      this.$confirm('当前用户已经报名这个课程了，确定要重复报名？').then(async () => {
        const { error }: any = await editContinueJoin(param)
        if (!error) {
          this.$router.go(-1)
          TagsViewModule.delView(this.$route)
        }
      })
    } else {
      this.$router.go(-1)
      TagsViewModule.delView(this.$route)
    }
  }
}
